// Recruitment timeline — classified mission phases, active phase highlighted.
import { PHASES, activePhaseIndex } from "@/lib/windows";
import { Reveal } from "@/components/Reveal";
import { Kicker } from "@/components/Section";

export const RecruitmentTimeline = () => {
  const active = activePhaseIndex();
  return (
    <section className="grain-dark relative border-y border-gold/20 bg-charcoal py-16 sm:py-24" data-testid="recruitment-timeline">
      <div className="halftone-gold pointer-events-none absolute inset-0 opacity-[0.03]" />
      <div className="relative mx-auto max-w-[1200px] px-4 sm:px-6">
        <Reveal>
          <div className="flex flex-wrap items-end justify-between gap-3">
            <div>
              <Kicker>Operation: Founding Cohort</Kicker>
              <h2 className="mt-4 font-display text-4xl uppercase leading-[0.9] tracking-tight text-metallic sm:text-5xl">Recruitment phases.</h2>
            </div>
            <p className="font-mono text-[9px] uppercase tracking-[0.35em] text-silver/40">Dossier BLV / OPS-2027 · Declassified</p>
          </div>
        </Reveal>
        <div className="mt-10 grid gap-4 md:grid-cols-2 lg:grid-cols-4">
          {PHASES.map((p, i) => {
            const state = i === active ? "active" : i < active ? "done" : "pending";
            return (
              <Reveal key={p.n} delay={i * 0.07}>
                <div
                  data-testid={`phase-${p.n}`}
                  className={`relative h-full border p-5 transition-colors ${
                    state === "active"
                      ? "border-gold bg-onyx shadow-[0_0_35px_rgba(201,162,39,0.2)]"
                      : state === "done"
                      ? "border-silver/20 bg-onyx/50"
                      : "border-silver/20 bg-onyx/70"
                  }`}
                >
                  <div className="flex items-start justify-between gap-2">
                    <span className={`font-cinzel text-3xl ${state === "active" ? "text-gold" : "text-silver/40"}`}>{p.n}</span>
                    <span className={`border px-1.5 py-0.5 font-mono text-[8px] font-bold uppercase tracking-[0.2em] ${
                      state === "active" ? "border-gold bg-gold/10 text-goldlight"
                      : state === "done" ? "border-silver/30 text-silver/40 line-through"
                      : "border-silver/30 text-silver/50"
                    }`}>
                      {state === "active" ? "IN EFFECT" : state === "done" ? "CONCLUDED" : "PENDING"}
                    </span>
                  </div>
                  <h3 className={`mt-3 font-display text-xl uppercase leading-none tracking-tight ${state === "active" ? "text-goldlight" : "text-cream"}`}>
                    Phase {p.n} — {p.code}
                  </h3>
                  <p className="mt-1.5 font-mono text-[10px] uppercase tracking-[0.2em] text-gold/80">{p.range}</p>
                  <p className={`mt-2 font-body text-sm leading-relaxed ${state === "done" ? "text-silver/45" : "text-silver/75"}`}>{p.body}</p>
                  {state === "active" && <span className="absolute -top-2 left-4 h-1.5 w-1.5 animate-pulse rotate-45 bg-gold" aria-hidden="true" />}
                </div>
              </Reveal>
            );
          })}
        </div>
        {active === -1 && (
          <p className="mt-5 font-mono text-[9px] uppercase tracking-[0.3em] text-silver/40" data-testid="pre-mission-note">
            Status: Pre-mission. Phase I begins August 24, 2026 — the file is open for review.
          </p>
        )}
      </div>
    </section>
  );
};
